import LatestMarineInfo from "../HomePage/LatestMarineInfo";
import ServicesBanner from "./ServicesBanner";
import ServiceSlider from "./ServiceSlider";
import Services from "../HomePage/Services";

function ServicesPage() {
  return (
    <>
      <ServicesBanner />
      <section className="latest-marine-info px-3" id="latest-marine-info">
        <div className="container max-1280">
          <ServiceSlider />
        </div>
      </section>
      <div className="new_bg_style">
        <Services />

  
      </div>
    </>
  );
}

export default ServicesPage;